import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/images/header_logo.png'


const _hoisted_1 = {
  key: 0,
  class: "w-full border-collapse border"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "border border-slate-300 px-4 font-semibold text-gray-700" }
const _hoisted_4 = { class: "border border-slate-300 px-4 font-semibold text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (Array.isArray(_ctx.store.state.user.user.roles) && _ctx.store.state.user.user.roles.length)
    ? (_openBlock(), _createElementBlock("table", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.store.state.user.user.roles, (role) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: role.id,
            onClick: ($event: any) => (_ctx.pushRoleCategoryList(role.slug)),
            class: "hover:bg-mentalncSuperLight hover:shadow-md cursor-pointer"
          }, [
            (!(role.slug === 'well_labo') && !(role.slug === 'welllabo_cancel'))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.is_yousei_group02)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (!(role.slug === 'yousei_online02') && !(role.slug === 'yousei_jitsugi02'))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[0] || (_cache[0] = _createElementVNode("th", { class: "border border-slate-300 p-1 w-12 md:w-14" }, [
                                _createElementVNode("img", {
                                  class: "w-full",
                                  src: _imports_0,
                                  alt: "LOGO"
                                })
                              ], -1)),
                              _createElementVNode("td", _hoisted_3, _toDisplayString(role.name), 1)
                            ], 64))
                          : _createCommentVNode("", true)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[1] || (_cache[1] = _createElementVNode("th", { class: "border border-slate-300 p-1 w-12 md:w-14" }, [
                          _createElementVNode("img", {
                            class: "w-full",
                            src: _imports_0,
                            alt: "LOGO"
                          })
                        ], -1)),
                        _createElementVNode("td", _hoisted_4, _toDisplayString(role.name), 1)
                      ], 64))
                ], 64))
              : _createCommentVNode("", true)
          ], 8, _hoisted_2))
        }), 128))
      ]))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createTextVNode(" 受講中の動画はありません。 ")
      ], 64))
}